import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 27 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "13",
  cy: "14",
  r: "12",
  stroke: "#FBEABC",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CFA432",
  "stroke-linecap": "round",
  "stroke-width": "3",
  d: "M13 2c6.627 0 12 5.373 12 12s-5.373 12-12 12c-3.79 0-7.169-1.757-9.368-4.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CFA432",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M13 10v4m0 4h.01"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }